import React from "react";

// Reusable classic pill switch. Correctly aligned thumb + smooth animation.
// color: "amber" | "emerald"
export function PillSwitch({ checked, onChange, label, color = "amber", disabled = false, testid }) {
  const onBg = color === "emerald" ? "bg-emerald-500" : "bg-amber-500";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      data-testid={testid}
      className={`group inline-flex items-center gap-2.5 text-sm text-slate-300 whitespace-nowrap ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-200 ${checked ? onBg : "bg-slate-700"}`}
      >
        <span
          className={`absolute left-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200 ease-out ${checked ? "translate-x-5" : "translate-x-0"}`}
        />
      </span>
      {label && <span>{label}</span>}
    </button>
  );
}

export default PillSwitch;
